export const createNotSupportedError = () => new DOMException('', 'NotSupportedError');
//# sourceMappingURL=not-supported-error.js.map